'use client';

import { ImageCouldFromRemoteServer as Image } from '@/components/images'
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

enum LogoTypeEnum {
	None = 0,
	Default = 1,
	FilterSaba = 2,
	Site = 3
}

export const Logo = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const view = useAppearanceStore(state => state.view);
	const defaultSrc = '/images/sites/default/logo.png';
	let src = '';

	if (SiteConfigsData?.GalaxyLogoType === LogoTypeEnum.None) {
		// do nothing
	} else if (SiteConfigsData?.GalaxyLogoType === LogoTypeEnum.Site) {
		const siteName = SiteConfigsData?.SiteName.toLowerCase();
		src = `/images/sites/${siteName}/logo.png`;
	} else if (SiteConfigsData?.GalaxyLogoType === LogoTypeEnum.FilterSaba || SiteConfigsData?.EnableFilterSaba) {
		src = '/images/sites/default/logo-customize.png';
	} else if (SiteConfigsData?.EnableSpecialEvent) {
		src = '/images/festival/new-year/logo-2026.png'; // 節慶
	} else if (view === ViewEnum.galaxy && SiteConfigsData?.EnablePHView) {
		src = '/images/sites/default/logo-basketball.png';
	} else if (SiteConfigsData?.GalaxyLogoType === LogoTypeEnum.Default) {
		src = defaultSrc;
	}

	return src ? (
		<Image
			src={src}
			alt=""
			width="180"
			height="66"
			priority={true}
			isGalaxyFolder={true}
			fallbackSrc={defaultSrc}
		/>
	) : null;
};
